import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[sharedUiModalFocusInput]',
    standalone: false
})
export class FocusInputDirective implements AfterViewInit {
  constructor(private eRef: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      const modalBody: HTMLElement = this.eRef.nativeElement.querySelector('.modal-body');

      if (modalBody) {
        const firstChild = modalBody.children[0] as HTMLElement;
        if (firstChild) {
          const hasInputOrTextArea = firstChild.querySelector('input, textarea') ? true : false;

          if (hasInputOrTextArea) {
            this.focusOn(firstChild);
          } else {
            const element: HTMLElement | null = modalBody.querySelector('#agree-field, #firstDigit');
            this.focusOn(element ?? undefined);
          }
        }
      }
    }, 0);
  }

  focusOn(element: HTMLElement | undefined): void {
    if (element) {
      if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
        element.focus();
      } else {
        (element.querySelector('input') ?? element.querySelector('textarea'))?.focus();
      }
    }
  }
}
